import Verge from 'verge';
import { debounce } from "debounce";

interface IViewPort {
    w: number,
    h: number,
}

export enum EBreakPoint {
    FULLHD,
    XXL,
    XL,
    LG,
    MD,
    SM,
    XS,
    XSPLUS,
}

const BreakPointSizes = {
    [EBreakPoint.FULLHD]: 1920,
    [EBreakPoint.XXL]: 1680,
    [EBreakPoint.XL]: 1440,
    [EBreakPoint.LG]: 1280,
    [EBreakPoint.MD]: 992,
    [EBreakPoint.SM]: 768,
    [EBreakPoint.XS]: 680,
    [EBreakPoint.XSPLUS]: 410,
};

class PBDevice {

    public vp :IViewPort = {w:0, h: 0};

    constructor() {
        this.initViewPort();
        window.onresize = debounce( () => {this.handleResize();}, 200);
    }

    public refresh(){
        this.initViewPort();
    }

    protected handleResize(){
        this.initViewPort();
    }

    protected initViewPort(){
        this.vp = {
            w: Verge.viewportW(),
            h: Verge.viewportH(),
        }
    }

    public is(breakpoint:EBreakPoint){

    }

    public isUpTo(bp:EBreakPoint, strictlyUp:boolean = false){

        if(strictlyUp){
            return (this.vp.w > BreakPointSizes[bp]);
        } else {
            return (this.vp.w >= BreakPointSizes[bp]);
        }

    }

    public isDownTo(bp:EBreakPoint, strictlyDown:boolean = false){
        if(strictlyDown){
            return (this.vp.w < BreakPointSizes[bp]);
        } else {
            return (this.vp.w <= BreakPointSizes[bp]);
        }
    }


}



export const Device = new PBDevice();
